import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  ShoppingCart as OrdersIcon,
  People as CustomersIcon,
  ViewList as ProductsIcon,
  Assessment as ReportsIcon,
  Group as TeamIcon,
  Settings as SettingsIcon,
  AdminPanelSettings as AdminIcon,
  Help as HelpIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { goToTrainingOrLogin } from '../../constants/training';

const MobileNavigation: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth.user);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Only show on mobile
  if (!isMobile) {
    return null;
  }

  const isAdmin = user?.role === 'Admin' || user?.role === 'SuperAdmin';

  // Essential mobile menu items - hide complex features
  const mobileMenuItems = [
    { 
      label: 'Dashboard', 
      icon: <DashboardIcon />, 
      path: '/dashboard',
      show: true 
    },
    { 
      label: 'Orders', 
      icon: <OrdersIcon />, 
      path: '/orders',
      show: true 
    },
    { 
      label: 'Customers', 
      icon: <CustomersIcon />, 
      path: '/customers',
      show: true 
    },
    { 
      label: 'Products', 
      icon: <ProductsIcon />, 
      path: '/products',
      show: true 
    },
    { 
      label: 'Reports', 
      icon: <ReportsIcon />, 
      path: '/reports',
      show: true 
    },
    { 
      label: 'Team', 
      icon: <TeamIcon />, 
      path: '/users',
      show: true 
    },
    { 
      label: 'Settings', 
      icon: <SettingsIcon />, 
      path: '/settings',
      show: true 
    },
    { 
      label: 'Admin', 
      icon: <AdminIcon />, 
      path: '/admin',
      show: isAdmin 
    },
    { 
      label: 'Help', 
      icon: <HelpIcon />, 
      path: '/training-demo',
      show: true,
      isExternal: true
    },
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const handleHelp = () => {
    goToTrainingOrLogin(navigate);
  };

  const getCurrentValue = () => {
    const currentItem = mobileMenuItems.find(item => 
      item.show && location.pathname.startsWith(item.path)
    );
    return currentItem ? currentItem.path : '/dashboard';
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: theme.zIndex.appBar,
        display: { xs: 'block', sm: 'none' }
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={(event, newValue) => {
          const item = mobileMenuItems.find(menuItem => menuItem.path === newValue);
          if (item?.isExternal) {
            handleHelp();
          } else {
            handleNavigation(newValue);
          }
        }}
        showLabels
        sx={{
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0 8px',
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            marginTop: '4px',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        {mobileMenuItems
          .filter(item => item.show)
          .map((item) => (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              icon={item.icon}
              value={item.path}
            />
          ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileNavigation;

